import React from 'react';
import InputField from 'components/FormFields/InputField';

const EventName = ({ title, setTitle, isValid, onBlur }) => {
  return (
    <InputField
      name="event_name"
      label="Event Name"
      value={title}
      onChange={(e) => setTitle(e.target.value)}
      onBlur={onBlur}
      showError={!isValid && !title}
      required
    />
  );
};

export default EventName;
